const MARKETING_AUTH_HINT_COOKIE_NAME = 'sg_auth_hint';
const MARKETING_AUTH_HINT_COOKIE_VALUE = '1';
const MARKETING_AUTH_HINT_PARENT_DOMAIN = '.supply-guard.io';
const MARKETING_AUTH_HINT_PRODUCTION_HOST = 'app.supply-guard.io';

function resolveMarketingAuthHintDomain(hostname: string): string | null {
  const normalizedHostname = hostname.trim().toLowerCase();

  if (normalizedHostname === MARKETING_AUTH_HINT_PRODUCTION_HOST) {
    return MARKETING_AUTH_HINT_PARENT_DOMAIN;
  }

  return null;
}

export function buildMarketingAuthHintCookieValue(
  authenticated: boolean,
  hostname: string,
): string {
  const cookieSegments = authenticated
    ? [`${MARKETING_AUTH_HINT_COOKIE_NAME}=${MARKETING_AUTH_HINT_COOKIE_VALUE}`]
    : [`${MARKETING_AUTH_HINT_COOKIE_NAME}=`];

  const cookieDomain = resolveMarketingAuthHintDomain(hostname);
  if (cookieDomain) {
    cookieSegments.push(`Domain=${cookieDomain}`);
  }

  cookieSegments.push('Path=/');

  if (!authenticated) {
    cookieSegments.push('Max-Age=0');
  }

  cookieSegments.push('Secure', 'SameSite=Lax');

  return cookieSegments.join('; ');
}

export function syncMarketingAuthHintCookie(authenticated: boolean): void {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return;
  }

  document.cookie = buildMarketingAuthHintCookieValue(authenticated, window.location.hostname);
}

export function setMarketingAuthHintCookie(): void {
  syncMarketingAuthHintCookie(true);
}

export function clearMarketingAuthHintCookie(): void {
  syncMarketingAuthHintCookie(false);
}
